const apiDataSortReducer = (
    state = {},
    action: {
      type: "SET_API_DATA_SORT";
      payload: any;
    }
  ) => {
    switch (action.type) {
      case "SET_API_DATA_SORT":
        return { ...action.payload };
  
      default:
        return state;
    }
  };
  
  export default apiDataSortReducer;